import instance from '@/utils/axios';

/**
 * 报警处置
 * @param {*} data
 * @returns
 */
export function alarmDisposalServer(data) {
  return instance.post('airDefense/alarmEvent/insert', data);
}

/**
 * 获取全部人员
 * @returns
 */
export function allPersonServer(data = {}) {
  return instance.post('airDefense/emergencyCrew/findAll', data);
}

/**
 * 应急预案--全部
 * @param {*} data
 * @returns
 */

export function emergencyPlanFindAllServer(data = {}) {
  return instance.post('airDefense/emergencyPlan/findAll', data);
}

/**
 * 应急预案--分页
 * @param {*} data
 * @returns
 */
export function emergencyPlanPageServer(data) {
  return instance.post('airDefense/emergencyPlan/findList', data);
}

/**
 * 保存事件
 * @param {*} data
 * @returns
 */
export function saveEventServer(data) {
  return instance.post('airDefense/alarmEvent/save', data);
}

/**
 * 事件列表
 * @param {*} data
 * @returns
 */
export function eventListServer(data) {
  return instance.post('airDefense/alarmEvent/findList', data);
}
